import { lazy, Suspense, useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import HomePage from './pages/HomePage';
import NotFoundPage from './pages/NotFoundPage';
import { trackPageView } from './lib/tracking';

// Lazy routes - tylko HomePage eager (first paint). Reszta lazy -> mniejszy initial bundle.
const QuizPage = lazy(() => import('./pages/QuizPage'));
const UslugiPage = lazy(() => import('./pages/UslugiPage'));
const RealizacjePage = lazy(() => import('./pages/RealizacjePage'));
const RoiCalculatorPage = lazy(() => import('./pages/RoiCalculatorPage'));
const BlogPage = lazy(() => import('./pages/BlogPage'));
const BlogPostPage = lazy(() => import('./pages/BlogPostPage'));
const NicheLandingPage = lazy(() => import('./pages/NicheLandingPage'));
const NicheThankYouPage = lazy(() => import('./pages/NicheThankYouPage'));
const PrivacyPage = lazy(() => import('./pages/LegalPage').then((m) => ({ default: m.PrivacyPage })));
const RodoPage = lazy(() => import('./pages/LegalPage').then((m) => ({ default: m.RodoPage })));
const CookiesPage = lazy(() => import('./pages/LegalPage').then((m) => ({ default: m.CookiesPage })));
const TermsPage = lazy(() => import('./pages/LegalPage').then((m) => ({ default: m.TermsPage })));
const CookieBanner = lazy(() => import('./components/CookieBanner'));

const PageFallback = () => <div className="min-h-screen bg-bg" />;

function App() {
  const location = useLocation();

  // Globalny page view na kazdej zmianie trasy (SPA). Consent-gated w trackPageView.
  useEffect(() => {
    trackPageView(location.pathname);
  }, [location.pathname]);

  return (
    <div className="bg-bg min-h-screen text-text-primary">
      <Suspense fallback={<PageFallback />}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/quiz" element={<QuizPage />} />
          <Route path="/lp/:slug" element={<NicheLandingPage />} />
          <Route path="/lp/:slug/thank-you" element={<NicheThankYouPage />} />
          <Route path="/uslugi" element={<UslugiPage />} />
          <Route path="/realizacje" element={<RealizacjePage />} />
          <Route path="/kalkulator-roi" element={<RoiCalculatorPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/polityka-prywatnosci" element={<PrivacyPage />} />
          <Route path="/rodo" element={<RodoPage />} />
          <Route path="/polityka-cookies" element={<CookiesPage />} />
          <Route path="/regulamin" element={<TermsPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Suspense>
      <Suspense fallback={null}><CookieBanner /></Suspense>
    </div>
  );
}

export default App;
